import axios from 'axios';
import TranslationsITBPER from './../files/translations-it-bper.json';
import TranslationsENBPER from './../files/translations-en-bper.json';
import TranslationsITBDS from './../files/translations-it-bds.json';
import TranslationsENBDS from './../files/translations-en-bds.json';

const DEFAULT_DISTANCE = 40000;
const DEFAULT_LIMIT_RESULTS = 5;
const DEFAULT_ZOOM_NO_DISTANCE = 15;

class MapService {
	static zoomToRadius(zoom) {
		let radius;
		switch (zoom) {
			case 20: radius = 1128.497220; break
			case 19: radius = 2256.994440; break;
			case 18: radius = 4513.988880; break;
			case 17: radius = 9027.977761; break;
			case 16: radius = 18055.955520; break;
			case 15: radius = 36111.911040; break;
			case 14: radius = 72223.822090; break;
			case 13: radius = 144447.644200; break;
			case 12: radius = 288895.288400; break;
			case 11: radius = 577790.576700; break;
			case 10: radius = 1155581.153000; break;
			case 9: radius = 2311162.307000; break;
			case 8: radius = 4622324.614000; break;
			case 7: radius = 9244649.227000; break;
			case 6: radius = 18489298.450000; break;
			case 5: radius = 36978596.910000; break;
			case 4: radius = 73957193.820000; break;
			case 3: radius = 147914387.600000; break;
			case 2: radius = 295828775.300000; break;
			case 1: radius = 591657550.500000; break;
			default: radius = 1128.497220;
		}
		return radius;
	}

	static async getConfigurations(bank) {
		return axios.get("/o/bper-api/subsidiary/configuration");
	}

	static async getTranslations(language, bank) {
		if (language === "it") {
			if (bank === "05387") {
				return await TranslationsITBPER;
			}
			if (bank === "01015") {
				return await TranslationsITBDS;
			}
		}
		if (language === "en") {
			if (bank === "05387") {
				return await TranslationsENBPER;
			}
			if (bank === "01015") {
				return await TranslationsENBDS;
			}
		}
		return await TranslationsITBPER;
	}

	static async getRegions(bank, basic) {
		const config = {
			method: 'get',
			headers: { 'Authorization': 'Basic ' + basic }
		};
		return axios.get("/o/bper-api/subsidiary/regions", config);
	}

	static async getRegionSubsidiary(groupId, bank, categories) {
		let arrayCategories = [];
		if (categories !== undefined) {
			categories.forEach((el) => (arrayCategories.push(el)));
		}

		const data = {
			abiCode: bank,
			groupId: groupId + "",
			categoryIds: arrayCategories,
		}

		return axios({
			method: 'post',
			url: "/o/bper-api/subsidiary/search/categories",
			data: data
		});
	}

	static async getCategories(groupId, bank, basic) {
		const config = {
			method: 'get',
			headers: { 'Authorization': 'Basic ' + basic }
		};
		return axios.get("/o/bper-api/subsidiary/filters/" + groupId, config);
	}

	static async getSubsidiary(groupId, bank, subsidiaryId) {
		const config = {
			method: 'get',
			headers: { 'Content-Type': 'application/json' }
		};

		return axios.get("/o/bper-api/subsidiary/" + groupId + "/" + subsidiaryId, config);
	}

	static async getResultsNumber(bank, filter, place, zoom, numberOfResults, distance, groupId) {
		const filterCategory = filter && filter.category;
		const filterServices = filter && filter.services;
		const latitude = place && place.lat;
		const longitude = place && place.lng;
		const limitResults = 2000;
		const zoomDef = distance === 0 ? DEFAULT_ZOOM_NO_DISTANCE : zoom;
		const radius = (distance && distance !== 0) ? distance : isFinite(zoomDef) ? this.zoomToRadius(zoomDef) : DEFAULT_DISTANCE;

		let services = [filterCategory];
		if (filterServices !== undefined) {
			filterServices.forEach((el) => (services.push(el)));
		}

		const data = {
			latitude: latitude,
			longitude: longitude,
			categoryIds: services,
			abiCode: bank,
			limitResults: limitResults,
			radius: parseInt(radius),
			groupId: groupId
		}

		return axios({
			method: 'post',
			url: "/o/bper-api/subsidiary/search/count",
			data: data
		});
	}

	static async getClosestSubsidiary(bank, limitResults, groupId, subsidiaryId) {
		const data = {
			abiCode: bank,
			countClosestSubsidiaries: limitResults ? limitResults : DEFAULT_LIMIT_RESULTS,
			identifier: subsidiaryId,
			groupId: groupId
		}
		try {
			return axios({
				method: 'post',
				url: "/o/bper-api/subsidiary/search/closest/subsidiaries",
				data: data
			});
		} catch (err) {
			console.error("Error getClosestSubsidiary", err);
		}
	}

	static async getSubsidiaries(bank, filter, place, zoom, numberOfResults, distance, groupId, default_zoom_distance, token, typeOfCaptcha) {
		const filterCategory = filter ? filter.category : undefined;
		const filterServices = filter ? filter.services : undefined;
		const latitude = place ? place.lat : 45.9658938;
		const longitude = place ? place.lng : 12.6400404;
		const limitResults = numberOfResults;
		const zoomDef = distance === 0 ? (default_zoom_distance ? default_zoom_distance : DEFAULT_ZOOM_NO_DISTANCE) : zoom;
		const radius = (distance && distance !== 0) ? distance : isFinite(zoomDef) ? this.zoomToRadius(zoomDef) : DEFAULT_DISTANCE;

		let services = filterCategory ? [filterCategory] : [];
		if (filterServices !== undefined) {
			filterServices.forEach((el) => (services.push(el)));
		}

		const data = {
			latitude: latitude,
			longitude: longitude,
			categoryIds: services,
			abiCode: bank,
			limitResults: limitResults,
			radius: parseInt(radius),
			groupId: groupId,
			token: token,
			typeRecaptcha: typeOfCaptcha
		}

		//console.log("getSubsidiaries", zoom, zoomDef, distance, radius);

		try {
			return axios({
				method: 'post',
				url: "/o/bper-api/subsidiary/search",
				data: data
			});
		} catch (err) {
			console.error("Error getSubsidiary", err);
		}
	}
}

export default MapService;
